import { TCommonData, TMargin, TWidget, TWidgetProps } from '@libs/types';
import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';
import loading from '../../animations/loading.json';
import { sanitizeLottieName } from '../../utils/sanitize';
import { getInlineStyles } from '../../utils/styles';

type TLoadingAnimation =
    | ({
          isWidget: true;
      } & TWidgetProps<TCommonData>)
    | {
          isWidget: false;
          margin?: TMargin;
      };

export const LoadingAnimation = (props: TLoadingAnimation) => {
    const finalWidget = props.isWidget
        ? props.widget
        : ({
              uid: 'loader',
              options: { margin: props.margin },
          } as TWidget<TCommonData>);
    const element = useRef<HTMLDivElement>(null);
    const sanitizedUid = sanitizeLottieName(finalWidget.uid);

    useEffect(() => {
        if (element.current) {
            lottie.loadAnimation({
                name: sanitizedUid,
                container: element.current,
                animationData: loading,
                renderer: 'svg',
                loop: true,
                autoplay: true,
            });
        }
        return () => {
            lottie.destroy(sanitizedUid);
        };
    }, [sanitizedUid]);

    return <div data-test={finalWidget.uid} ref={element} style={getInlineStyles({ margin: finalWidget.options?.margin, height: '80px', width: '80px' })} />;
};
